"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["src", "alt", "href", "imgProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledLink = (0, _material.styled)("a")(function (_ref) {
  var theme = _ref.theme;
  return {
    marginLeft: theme.spacing(4)
  };
});
var StyledImg = (0, _material.styled)("img")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "block",
    maxHeight: theme.mixins.toolbar.minHeight,
    maxWidth: "9rem",
    width: "auto"
  };
});

var NavLogo = function NavLogo(_ref3) {
  var src = _ref3.src,
      alt = _ref3.alt,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? "#" : _ref3$href,
      imgProps = _ref3.imgProps,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread(_objectSpread({
    href: href
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImg, _objectSpread({
      alt: alt,
      src: src
    }, imgProps))
  }));
};

var _default = NavLogo;
exports.default = _default;